import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
function ServiceProviderDisclosures() {
    return (_jsxs("div", { className: "stepper-end", children: [_jsx("p", { children: "**Not a final credit decision." }), _jsxs("p", { children: ["- Alphaeon Credit Card Accounts are issued by Comenity Capital Bank", ' ', _jsx("br", {}), "Credit card offers are subject to credit approval."] })] }));
}
export default memo(ServiceProviderDisclosures);
